<template>
  <div class="content" :class="platform">
    <Header1 :extras="extras"></Header1>
    <Banner :extras="extras"></Banner>
  </div>
</template>
<script>
import Header1 from "../../stempcore/src/core/components/common/Header.vue";
import Banner from "../../stempcore/src/core/components/common/Banner.vue";
export default {
  name: "Header",
  props: ["extras", "platform"],
  data() {
    return {};
  },
  components: {
    Header1,
    Banner,
  },
};
</script>
